import { Col } from "./Col";
export { Col };
export default Col;
